import { FC } from 'react'
import { dateFormat } from '../../../helpers';
import { LoanTransaction } from '../../../interfaces';
import { NoContent } from '../../Common/NoContent';

type props = {
  loanTransactions: LoanTransaction[]
}

export const Transactions: FC<props> = ({ loanTransactions }) => {
  return (
    <>
      {loanTransactions && loanTransactions.length > 0 ? (
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted border-tr'>
                <th className='min-w-100px rounded-start'>Amount</th>
                <th className='min-w-100px'>Description</th>
                <th className='min-w-50px'>Created At</th>
                <th className='min-w-50px'>Updated At</th>
                {/* <th className='text-end rounded-end'></th> */}
              </tr>
            </thead>
            <tbody>
              {loanTransactions.map((transaction) => (
                <tr key={transaction.id}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <div className='text-dark fw-bold text-hover-primary mb-1 fs-7 text-capitalize'>{`${parseFloat(transaction.amount).toLocaleString()}`}</div>
                      </div>
                    </div>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{transaction.description ? transaction.description : 'N/A'}</span>
                  </td>
                  <td className='align-top'>
                    <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-7'>{dateFormat(transaction.created_at)}</span>
                  </td>
                  <td>
                    <span className='text-dark fw-bold d-block mb-1 fs-7'>{dateFormat(transaction.updated_at)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <NoContent message='There are no transactions at the moment' />}
    </>
  );
}
